import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import { cn } from "@/shared/lib/utils";

import { BUCKET_PILL_VARIANT } from "../../constants/cryptoSwaps.constants";
import { useCryptoSwapLabels } from "../../hooks/useCryptoSwapLabels";
import type { OtcOrderStatus } from "../../types/cryptoSwaps.types";
import { bucketForStatus, isNonTerminalStatus } from "../../utils/cryptoSwapStatus";

export interface CryptoSwapStatusPillProps {
  status: OtcOrderStatus;
  size?: "default" | "sm";
  className?: string;
}

/** The label always renders; the colour repeats it. The dot pulses while the USDT is on its way. */
export function CryptoSwapStatusPill({ status, size = "default", className }: CryptoSwapStatusPillProps) {
  const labels = useCryptoSwapLabels();
  const live = isNonTerminalStatus(status);

  return (
    <ColocaStatusPill
      variant={BUCKET_PILL_VARIANT[bucketForStatus(status)]}
      size={size}
      className={className}
    >
      <span
        aria-hidden="true"
        className={cn("size-1.5 shrink-0 rounded-full bg-current", live && "animate-pulse")}
      />
      {labels.status(status)}
    </ColocaStatusPill>
  );
}
